import { Grid, Button, FormControlLabel, Checkbox } from "@material-ui/core"
import { InferType } from "yup"
import { TextField } from 'formik-material-ui';
import { SaveOutlined } from "@material-ui/icons"
import { Field, useFormikContext } from "formik"
import { ticketStatusSchema } from "../TicketStatusContext"
import { useLocation } from "react-router";

let TicketStatusForm = () => {
    let location = useLocation();

    let isNew = location.pathname.includes('/addnew');

    type TicketStatus = InferType<typeof ticketStatusSchema>
    let formProps = useFormikContext<TicketStatus>()

    return (
        <>
            <Grid container>
                <Grid item xs>
                    <Field
                        component={TextField}
                        name="code"
                        label="Code"
                        disabled={isNew === false}
                        variant="outlined"
                        fullWidth
                    />
                </Grid>
                <Grid item xs={3}>
                    <Field
                        component={TextField}
                        name="sortOrder"
                        label="Sort Order"
                        variant="outlined"
                        type="number"
                    />
                </Grid>
                <Grid item xs={12}>
                    <Field
                        component={TextField}
                        name="name"
                        label="Videndum status"
                        variant="outlined"
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12}>
                    <Field
                        component={TextField}
                        name="customerVisibleStatus"
                        label="Customer status"
                        variant="outlined"
                        fullWidth
                    />
                </Grid>

                <Grid item xs={12}>
                    <FormControlLabel
                        label="Is resolved"
                        name="isResolved"
                        value={formProps.values.isResolved}
                        checked={formProps.values.isResolved}
                        onChange={(e: any) => formProps.setFieldValue('isResolved', e.target.checked)}
                        control={<Field type="checkbox" name="isResolved" component={Checkbox} />}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel
                        label="Is initial status"
                        name="isInitialStatus"
                        value={formProps.values.isInitialStatus}
                        checked={formProps.values.isInitialStatus}
                        onChange={(e: any) => formProps.setFieldValue('isInitialStatus', e.target.checked)}
                        control={<Field type="checkbox" name="isInitialStatus" component={Checkbox} />}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel
                        label="Has automatic updates"
                        name="hasAutomaticUpdates"
                        value={formProps.values.hasAutomaticUpdates}
                        checked={formProps.values.hasAutomaticUpdates}
                        onChange={(e: any) => formProps.setFieldValue('hasAutomaticUpdates', e.target.checked)}
                        control={<Field type="checkbox" name="hasAutomaticUpdates" component={Checkbox} />}
                    />
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs />
                <Grid item>
                    <Button type="submit" color="secondary" variant="contained">
                        <SaveOutlined />&nbsp;Save
                    </Button>
                </Grid>
            </Grid>
        </>
    )
}

export default TicketStatusForm

